import { useContext } from "react";
import { ResumeContext } from "../context/resume/resume-context";
import { parseISO } from "date-fns";

export default function useResumeDocumentSection() {
    const { resumeData } = useContext( ResumeContext );
    return extractResumeDataDocumentSection(resumeData);
}

export function extractResumeDataDocumentSection(resumeData) {
    return {
        user: resumeData?.document?.user || { firstName: '', lastName: '' },
        introduction: resumeData?.document?.introduction || '',
        languageSkills: resumeData?.document?.languageSkills || [],
        businessSkills: resumeData?.document?.businessSkills || [],
        experiences: [ ...( resumeData?.document?.experiences || [] ) ]
            .sort((a, b) => parseISO(b?.from) - parseISO(a?.from)),
        totalExperienceDuration: resumeData?.document?.totalExperienceDuration || 0,
        diplomas: resumeData?.document?.diplomas || [],
        hobbies: resumeData?.document?.hobbies || []
    };
}
